import React, { useEffect, useState } from "react";
import { Table, Button, Toast } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";
import { selectSindromesAnalisis } from "../../../state/sindrome/selectors";
import { selectHomeosiniatria } from "../../../state/homeosiniatria/selectors";

import { repertorizarHomeosiniatria } from "../../../services/repertorizarHomeosiniatria";
import { agregarHomeosiniatria } from "../../../state/homeosiniatria/actions";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer } from "react-toastify";
import StyledLink from "../../general/StyledLink";

const ToastData = ({ title, sindromes }) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <Button
        variant="default"
        data-toggle="tooltip"
        data-placement="top"
        title={`Ver ${title}`}
        onClick={() => {
          setShow(!show);
        }}
      >
        <FontAwesomeIcon icon={faEye} />
      </Button>
      {show ? (
        <Toast show={show} onClose={() => setShow(!show)}>
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded mr-2"
              alt=""
            />
            <strong className="mr-auto">{title}</strong>
          </Toast.Header>
          <Toast.Body>
            {sindromes.map(({ cod, nombre }) => {
              return (
                <div key={cod} className="d-flex justify-content-between">
                  <p>{nombre}</p>
                </div>
              );
            })}
          </Toast.Body>
        </Toast>
      ) : null}

      <ToastContainer />
    </>
  );
};

const TablaHomeosiniartia = () => {
  const homeosiniatria = useSelector(selectHomeosiniatria);
  const sindromes = useSelector(selectSindromesAnalisis);
  const dispatch = useDispatch();

  useEffect(() => {
    const cargarHomeosiniatria = async () => {
      const codigosSindromes = sindromes.map((element) => {
        return element.codSindrome;
      });
      const newHomeosiniatriaState =
        await repertorizarHomeosiniatria(codigosSindromes);

      dispatch(agregarHomeosiniatria(newHomeosiniatriaState));
    };
    cargarHomeosiniatria();
  }, [sindromes, dispatch]);

  const renderBody = () => {
    return homeosiniatria.map((item, index) => {
      if (index < 10) {
        return (
          <tr key={index}>
            <td>
              <StyledLink to={`/libro/12?page=35`}>{item.nombre}</StyledLink>
            </td>
            <td>
              <div className="d-flex justify-content-between">
                {item.total}
                <ToastData title="sindromes" sindromes={item.sindrome} />
              </div>
            </td>
          </tr>
        );
      }
      return null;
    });
  };

  if (homeosiniatria.length === 0) {
    return (
      <p>Agrega síntomas para ver información relacionada con homeosiniatria</p>
    );
  }

  return (
    <Table striped>
      <thead>
        <tr>
          <th scope="col">Homeosiniatria</th>
          <th scope="col">Número de síndromes</th>
        </tr>
      </thead>
      <tbody>{renderBody()}</tbody>
    </Table>
  );
};

export default TablaHomeosiniartia;
